import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { BehaviorSubject } from 'rxjs';
import { IHeaderParams } from '@ag-grid-community/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';

export interface AgQuarterCloseCollapsableHeaderParams extends IHeaderParams {
  columns: string[];
}

@Component({
  standalone: true,
  template: `
    <div class="flex items-center space-x-2">
      <div *ngIf="params.template" [innerHTML]="params.template"></div>

      <button
        *ngIf="columns.length"
        class="flex items-center no-underline aux-link"
        (click)="onToggle()"
      >
        <span
          class="text-aux-gray-darkest"
          inlineSVG="chevron-right.svg"
          [ngClass]="{
            'transform rotate-180': (collapsed$ | async) === false
          }"
          [setSVGAttributes]="{ class: 'w-4 h-4' }"
        ></span>
      </button>
    </div>
  `,
  imports: [NgIf, InlineSVGModule, AsyncPipe, NgClass],
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgQuarterCloseCollapsableHeaderComponent implements IHeaderAngularComp {
  params!: AgQuarterCloseCollapsableHeaderParams;

  collapsed$ = new BehaviorSubject(true);

  columns: string[] = [];

  agInit(params: AgQuarterCloseCollapsableHeaderParams) {
    this.params = params;
    this.columns = params.columns;
  }

  refresh(): boolean {
    return false;
  }

  onToggle() {
    const bool = !this.collapsed$.getValue();
    this.params?.columnApi.setColumnsVisible(this.columns, !bool);
    this.collapsed$.next(bool);
  }
}
